import { MarketingDataParam } from "@types";

export const MARKETING_DATA_PARAMS: MarketingDataParam[] = [
  MarketingDataParam.PIXEL_ID,
  MarketingDataParam.FBCL_ID,
  MarketingDataParam.CODE,
];
